var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import React, { Component } from 'react';
import { Tooltip } from '@cimpress/react-components';
import { getCombinedErrorMessage } from '../utils/utils';

var PriceCellRenderer =
/** @class */
function (_super) {
  __extends(PriceCellRenderer, _super);

  function PriceCellRenderer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PriceCellRenderer.prototype.render = function () {
    var value = this.props.value;
    var displayValue = value;

    if (value === null || value === undefined) {
      displayValue = '-';
    } else if (typeof value === 'object') {
      var productPrice = value.productPrice,
          shippingPrice = value.shippingPrice,
          errorMessage = value.errorMessage,
          shippingErrorMessage = value.shippingErrorMessage;
      var displayPrice = '-';
      var displayShippingPrice = '';

      if (productPrice && productPrice.displayPrice) {
        var price = productPrice.displayPrice;
        var currency = productPrice.currency;
        price = typeof price === 'string' ? parseFloat(price) : price;
        displayPrice = currency ? price.toLocaleString(undefined, {
          style: 'currency',
          currency: currency
        }) : price;

        if (shippingPrice && shippingPrice.displayShippingPrice !== undefined) {
          var shipPrice = shippingPrice.displayShippingPrice; // eslint-disable-next-line no-shadow

          var currency_1 = shippingPrice.currency;
          shipPrice = typeof shipPrice === 'string' ? parseFloat(shipPrice) : shipPrice;
          displayShippingPrice = currency_1 ? shipPrice.toLocaleString(undefined, {
            style: 'currency',
            currency: currency_1
          }) : shipPrice;
          displayShippingPrice = displayShippingPrice ? "+ Shipping " + displayShippingPrice : '';
        }
      }

      var priceCell = React.createElement("div", {
        className: "price-cell"
      }, React.createElement("span", null, displayPrice), React.createElement("br", null), React.createElement("span", {
        style: {
          display: 'flex',
          marginTop: '-10px',
          float: 'right',
          fontSize: '10px'
        }
      }, displayShippingPrice));
      var message = getCombinedErrorMessage(errorMessage, shippingErrorMessage);

      if (message) {
        return React.createElement("div", null, React.createElement(Tooltip, {
          direction: "right",
          contents: message,
          className: "honor-newlines",
          style: {
            height: '100%',
            width: '100%'
          }
        }, priceCell));
      }

      return priceCell;
    }

    return React.createElement("span", null, displayValue);
  };

  return PriceCellRenderer;
}(Component);

export default PriceCellRenderer;